<eventq-dialog-popover
  [open]="open()"
  [title]="cameraName()"
  [showFooter]="false"
  placement="center"
  panelClass="eventq-dialog-popover__panel--view-alarm"
  [panelWidth]="panelWidth()"
  [panelHeight]="panelHeight()"
  [panelMaxHeight]="panelMaxHeight()"
  (closed)="closed.emit()"
>
  <div class="view-alarm-popover">
    <div class="view-alarm-popover__url">
      <div class="view-alarm-popover__url-field">
        <span class="view-alarm-popover__url-label">URL</span>
        <p class="view-alarm-popover__url-value">{{ urlValue() }}</p>
      </div>
    </div>

    <div class="view-alarm-popover__playback" tabindex="0">
      <ng-content />
    </div>

    <footer class="view-alarm-popover__footer">
      <div class="view-alarm-popover__nav">
        <button
          type="button"
          class="view-alarm-popover__nav-btn"
          [disabled]="!hasPrevAlarm()"
          (click)="prevAlarm.emit()"
        >
          <img [src]="'/assets/library-icons/skip_previous.svg' | prefixUrl" alt="" aria-hidden="true" />
          <span>Show Prev Alarm</span>
        </button>
        <button
          type="button"
          class="view-alarm-popover__nav-btn"
          [disabled]="!hasNextAlarm()"
          (click)="nextAlarm.emit()"
        >
          <span>Show Next Alarm</span>
          <img [src]="'/assets/library-icons/skip_next.svg' | prefixUrl" alt="" aria-hidden="true" />
        </button>
      </div>
      <div class="view-alarm-popover__flag">
        <span>Flag Alarm</span>
        <eventq-flag-alarm-toggle
          [flagged]="flagged()"
          (flaggedChange)="flaggedChange.emit($event)"
        />
      </div>
    </footer>
  </div>
</eventq-dialog-popover>
